module.exports = __webpack_public_path__ + "static/media/DebadityaB.a1fedef1.jpg";